import { combineReducers } from "redux";
import { alertReducer } from "./alertReducer";
import { confirmModalReducer } from "./confirmModalReducer";
import { authReducer } from "./authReducer";
import { migrationReducer } from "./migrationReducer";
import { policiesReducer } from "./policiesReducer";
import { applicationReducer } from "./applicationReducer";
import { metadataReducer } from "./metadataReducer";
import { groupReducer } from "./groupReducer";
import { userReducer } from "./userReducer";
import { validationReducer } from "./validationReducer";
import { fileReaderReducer } from "./fileReaderReducer";
import { onboardingReducer } from "./onboardingReducer";
import { logReducer } from "./logReducer";
import { resetPasswordReducer } from "./resetPasswordReducer";
import { otpReducer } from "./otpReducer";
import { dashboardReducer } from "./dashboardReducer";
import { changePasswordReducer } from "./changePasswordReducer";
import { otpRotationReducer } from "./otpRotationReducer";

export const rootReducer = combineReducers({
  authReducer,
  migrationReducer,
  alertReducer,
  confirmModalReducer,
  policiesReducer,
  applicationReducer,
  metadataReducer,
  groupReducer,
  userReducer,
  validationReducer,
  fileReaderReducer,
  onboardingReducer,
  logReducer,
  resetPasswordReducer,
  otpReducer,
  dashboardReducer,
  changePasswordReducer,
  otpRotationReducer
});
